import { FluxStandardAction } from 'flux-standard-action'
import {
  GET_REPORT_LOGS,
  GET_REPORT_LOG_DETAILS,
} from '../constants/report.constant'
import { DayTrainingLog } from '../interfaces/day-training-log'
export const setDayReportLogs = (
  result: DayTrainingLog[]
): FluxStandardAction<any, any> => ({
  type: GET_REPORT_LOGS,
  payload: result,
  meta: null,
})
export const setDayReporLogDetails = (
  result: DayTrainingLog
): FluxStandardAction<any, any> => ({
  type: GET_REPORT_LOG_DETAILS,
  payload: result,
  meta: null,
})



// WEBPACK FOOTER //
// ./src/actions/report.action.ts